<mat-form-field [appearance]="appearance" class="width-100">
  <mat-progress-bar mode="buffer" *ngIf="!orderedData"></mat-progress-bar>
  <mat-label>{{label}}</mat-label>
  <mat-select class="width-100"
              [formControl]="selectFormControl"
              [placeholder]="label"
              [compareWith]="compareWith"
              [required]="required">
    <mat-option *ngFor="let option of orderedData" [value]="option.value">
      <button mat-button
              matSuffix
              mat-icon-button
              appClickStopPropagation
              *ngIf="option.tooltip"
              (click)="peek(option)">
        <mat-icon>visibility</mat-icon>
      </button>
      {{option.label}}
    </mat-option>
  </mat-select>
  <button mat-button
          matSuffix
          mat-icon-button
          appClickStopPropagation
          *ngIf="this.selectFormControl.value"
          [disabled]="selectFormControl.disabled"
          (click)="clear()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
